import React from 'react';
import {
  Body,
  Card,
  CardBody,
  Header,
  TextHeader,
  TitleHeader
} from '../Styles/ReinforcementCardStyle';
import IconPresencial from '../../../../assets/icons/map-pin.svg';
import IconRemote from '../../../../assets/icons/reinforcement/IconRemote.svg';
import TagFeatured from '../../events/components/TagFeatured';
import TextHelper from '../../../../core/helpers/TextHelper';
import TagRescheduled from '../../events/components/TagRescheduled';
import { CardCanceled } from '../../events/components/body/inscriptions/InscriptionsStyled';
import RemotoCancelado from '../../../../assets/icons/events/RemotoCancelado.svg';
import presencialCancelado from '../../../../assets/icons/events/presencialCancelado.svg';
import ReusableDate from '../../../reusables/Date';
import { CardText1 } from '../../events/components/body/EventsBodyStyled';
import Tag from '@/presentation/reusables/Tag';
import { WaintingListStatus } from '../../events/constants';

interface ReinforcementCardProps {
  courseId?: string;
  selectReinforcement: (id: string, courseId: string) => void;
  cardInfo: any;
}

export const getWaitingListStatus = (status: string) => {
  if (status === WaintingListStatus.IN_WAITING_LIST) {
    return { name: 'En espera', color: '#456271' };
  }
  if (status === WaintingListStatus.REGISTERED) {
    return { name: 'Inscrito', color: '#005C27' };
  }
  if (status === WaintingListStatus.ENABLED_TO_REGISTER) {
    return { name: 'Vacante disponible', color: '#0060AB' };
  }
  return { name: '', color: '' };
};

const ReinforcementCard = (props: ReinforcementCardProps) => {
  const { courseId, selectReinforcement, cardInfo } = props;
  const { name, color } = getWaitingListStatus(cardInfo.statusWaitingList);
  return (
    <Card
      onClick={() => selectReinforcement(cardInfo.id, courseId ?? '')}
      data-testid="cmp-reinforcement-card"
      className={cardInfo.isCancel === true ? 'eventoCancelado' : ''}
      type="button"
    >
      <Header>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <TitleHeader>
            {cardInfo.name.length > 60
              ? `${TextHelper.capitalize(cardInfo.name, true).substring(
                  0,
                  60
                )}...`
              : cardInfo.name}
          </TitleHeader>
          <TextHeader>
            {cardInfo.isCancel ? (
              <CardCanceled>Cancelado</CardCanceled>
            ) : (
              <div style={{ gap: 4, display: 'flex' }}>
                {cardInfo.customIsToday && <CardText1>Hoy</CardText1>}
                {cardInfo.isFeatured && <TagFeatured isCard />}
                {cardInfo.statusWaitingList && (
                  <Tag color={color} title={name} weight="400" />
                )}
                {cardInfo.isSubscribed && (
                  <Tag color="#005C27" title="Inscrito" weight="400" />
                )}
              </div>
            )}
          </TextHeader>
        </div>
      </Header>
      <Body>
        <CardBody>
          <div className="flexCalendar">
            <ReusableDate
              size="medium"
              isDisabled={cardInfo.isCancel}
              endDate={cardInfo?.date}
              fontSize="14px"
              gap="4px"
              startDate={cardInfo?.date}
              style={{ color: 'blue' }}
            />
            <TagRescheduled
              isRescheduled={cardInfo.isRescheduled}
              colorProp="#0071BF"
              isCanceled={cardInfo.isCancel}
            />
          </div>
        </CardBody>
        <CardBody>
          <div className="displayFlex">
            {cardInfo.hourStart} - {cardInfo.hourEnd}
            {/* <img src={IconClock} alt="IconClock" width={16} height={16} />
              <p className="DF">
                {cardInfo.hourStart} - {cardInfo.hourEnd}
              </p> */}
          </div>
        </CardBody>
        <CardBody>
          <div className="row">
            <p>
              Tutor(a){' '}
              {TextHelper.capitalize(cardInfo?.nameTeacher.replace(',', ', '))}
            </p>
          </div>
        </CardBody>
        <CardBody>
          <div className="courseModality">
            {cardInfo.isCancel && (
              <>
                <img
                  style={{
                    width: '20px',
                    height: '20px',
                    filter: 'inherit'
                  }}
                  src={
                    cardInfo.modality.code === 'P'
                      ? presencialCancelado
                      : RemotoCancelado
                  }
                  alt="Iconmodality"
                />
                {cardInfo.modality.code === 'P' ? (
                  <span>{cardInfo.classRoomCode}</span>
                ) : (
                  <span>Zoom</span>
                )}
              </>
            )}
            {!cardInfo?.isCancel && (
              <>
                <img
                  style={{
                    width: '20px',
                    height: '20px'
                  }}
                  src={
                    cardInfo.modality.code === 'P' ? IconPresencial : IconRemote
                  }
                  alt="Iconmodality"
                />
                {cardInfo.modality.code === 'P' ? (
                  <span>{cardInfo.classRoomCode}</span>
                ) : (
                  <span>Zoom</span>
                )}
              </>
            )}
          </div>
        </CardBody>
      </Body>
    </Card>
  );
};

export default ReinforcementCard;
